<template>
    <input ref="input" :type="type" :class="inputClass" :disabled="disabled" class="form-control" :value="numberStr" :min="type === 'number' ? min : null" :max="type === 'number' ? max : null" v-on:input="onInput" v-on:blur="onBlur" v-on:focus="onFocus" v-on:keypress.enter="blur"/>
</template>

<script>

export default {
    props:{
        value:Number,
        min:{
            type:Number,
            default:null
        },
        max:{
            type:Number,
            default:null
        },
        disabled:{
            type:Boolean,
            default:null
        },
        inputClass:{
            type:String,
            default:null
        }
    },
    data(){
        return{
            type:'text',
            numberStr:""
        }
    },
    watch:{
        value(newV){
            if(this.type !== 'number' && !isNaN(newV)){
                this.numberStr = this.toNumberStr(this.value)
            }
        }
    },
    mounted(){
        this.numberStr = this.toNumberStr(this.value)
    },
    methods:{
        toNumberStr(n){
            let nn = n
            if(n == null || n == "" || n == NaN){ nn = 0 }
            return new Intl.NumberFormat('tr-TR', {
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(nn)
        },
        onInput($e){
            let value = parseFloat($e.target.value)
            if(isNaN(value)){
                this.$emit('updateValue',value)
                return
            }
            if(this.max != null && value > this.max){
                value = this.max
            }
            if(this.min != null && value < this.min){
                value = this.min
            }
            this.numberStr = value
            this.$emit('updateValue',value)
        },
        onBlur(){
            this.type = 'text'
            this.numberStr = this.toNumberStr(this.value)
        },
        onFocus(){
            this.numberStr = this.value
            this.type = 'number' 
        },
        blur(){
            this.$refs.input.blur()
        }
    },
}
</script>
